import { render, staticRenderFns } from "./reporteComprasNuevo.vue?vue&type=template&id=9da80b30&"
import script from "./reporteComprasNuevo.vue?vue&type=script&lang=js&"
export * from "./reporteComprasNuevo.vue?vue&type=script&lang=js&"
import style0 from "./reporteComprasNuevo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports